module.exports = __webpack_public_path__ + "img/c-thermometer-img7-1.9a1c4849.jpg";